import axios from 'axios';
export class CancelTokenService {
    static getToken(key) {
        if (!this.sources[key]) {
            this.sources[key] = [];
        }
        const source = axios.CancelToken.source();
        this.sources[key].push(source);
        return source.token;
    }
    static async cancel(key) {
        if (this.sources[key]) {
            while (this.sources[key].length > 0) {
                const source = this.sources[key].shift();
                source && source.cancel();
            }
        }
    }
    static cancelAndGetToken(key) {
        this.cancel(key);
        return this.getToken(key);
    }
    static async cancelAll() {
        Object.values(this.sources).forEach((sources) => {
            while (sources.length > 0) {
                const source = sources.shift();
                source && source.cancel();
            }
        });
    }
}
CancelTokenService.sources = {};
CancelTokenService.isCancel = (error) => axios.isCancel(error);
//# sourceMappingURL=cancel-token.service.js.map